module.exports = __webpack_public_path__ + "c718605912032dcde6fe787fb7c8a826.png";